import { createStructuredSelector } from 'reselect';

const showLockerSelector = (state: RootState) => state.globalLocker.showLocker;
const lockerTitleSelector = (state: RootState) => state.globalLocker.title ?? '';
const lockerAriaLabelSelector = (state: RootState) => state.globalLocker.ariaLabel ?? '';

export const globalLockerSelector = createStructuredSelector({
  showLocker: showLockerSelector,
  title: lockerTitleSelector,
  ariaLabel: lockerAriaLabelSelector,
});
